import React, { CSSProperties } from 'react';
type OrnamentProps = {
  className?: string;
  color?: string;
  style?: CSSProperties;
};
export function YinYang({
  className = '',
  color = '#A98546',
  style
}: OrnamentProps) {
  return <svg viewBox="0 0 24 24" className={className} style={style} fill="none" stroke={color} strokeWidth="1.3" strokeLinecap="round" aria-hidden="true" data-id="element-143" data-mp="34ylhce0cv4qe">
      <circle cx="12" cy="12" r="9.2" data-id="element-144" data-mp="39vkel5fbfrst" />
      <path d="M12 2.8a4.6 4.6 0 0 0 0 9.2 4.6 4.6 0 0 1 0 9.2" data-id="element-145" data-mp="2d8gtg5ddzzkf" />
      <path d="M12 6.6v.01M12 17.3v.01" data-id="element-146" data-mp="2h991ivaivyf4" />
    </svg>;
}
export function Needle({
  className = '',
  color = '#7C5F2A',
  style
}: OrnamentProps) {
  return <svg viewBox="0 0 24 24" className={className} style={style} fill="none" stroke={color} strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" data-id="element-147" data-mp="2m7kc588n6cye">
      <path d="M20.5 3.5 9 15" data-id="element-148" data-mp="1tkgejobvp0wn" />
      <path d="M17.6 2.2 21.8 6.4" data-id="element-149" data-mp="1tj59ll6p5n3y" />
      <path d="m9 15-2.2 5.4a.7.7 0 0 0 .9.9L13 19" data-id="element-150" data-mp="1yirp619zzffx" />
      <path d="M3.2 20.8 5 19" data-id="element-151" data-mp="1yhgj1ut2xvln" />
    </svg>;
}
export function Bamboo({
  className = '',
  color = '#4A6B57',
  style
}: OrnamentProps) {
  return <svg viewBox="0 0 24 24" className={className} style={style} fill="none" stroke={color} strokeWidth="1.35" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" data-id="element-152" data-mp="31vv91vzrwmuq">
      <path d="M9 22V2M9 7h3M9 13h3M9 18h3" data-id="element-153" data-mp="2x3bsqr9pbdm8" />
      <path d="M12 9c3.4-.6 5.6-2.4 6.6-5-3.2-.4-5.6 1.2-6.6 5Z" data-id="element-154" data-mp="2s6liwlohpe99" />
      <path d="M12 16c3.2-.3 5.4 1 6.6 3.4-3.2.7-5.6-.3-6.6-3.4Z" data-id="element-155" data-mp="2s490k7etl1vo" />
    </svg>;
}
export function Mandala({
  className = '',
  color = '#A98546',
  style
}: OrnamentProps) {
  return <svg viewBox="0 0 100 100" className={className} style={style} fill="none" stroke={color} strokeWidth="1" aria-hidden="true" data-id="element-156" data-mp="2i6ksygw47zw3">
      <circle cx="50" cy="50" r="44" data-id="element-157" data-mp="2977jvpbwldbw" />
      <circle cx="50" cy="50" r="30" data-id="element-158" data-mp="298952mmmvg7c" />
      <circle cx="50" cy="50" r="12" data-id="element-159" data-mp="299ak126rsmuc" />
      <path d="M50 6v88M6 50h88M18.9 18.9l62.2 62.2M81.1 18.9 18.9 81.1" data-id="element-160" data-mp="cfh344ray63f" />
      <path d="M50 20c10 9 10 21 0 30-10-9-10-21 0-30ZM50 50c10 9 10 21 0 30-10-9-10-21 0-30ZM20 50c9-10 21-10 30 0-9 10-21 10-30 0ZM50 50c9-10 21-10 30 0-9 10-21 10-30 0Z" data-id="element-161" data-mp="7furfzr4gxwq" />
    </svg>;
}
type SealProps = {
  characters?: string;
  className?: string;
};
export function Seal({
  characters = '針灸',
  className = ''
}: SealProps) {
  return <span className={`inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-[4px] bg-brand-burgundy p-1 text-center font-kanji text-[13px] font-bold leading-[1.05] text-brand-paper shadow-[0_2px_8px_rgba(122,42,32,0.3)] ${className}`} aria-hidden="true" data-id="element-162" data-mp="hkkn5nvxn5si">
      {characters}
    </span>;
}
type KanjiBackdropProps = {
  glyphs?: string[];
  className?: string;
};

/** Decorative column of oversized Chinese characters behind a section. */
export function KanjiBackdrop({
  glyphs = ['氣', '經', '絡', '陰', '陽'],
  className = ''
}: KanjiBackdropProps) {
  return <div className={`pointer-events-none absolute inset-0 -z-10 overflow-hidden ${className}`} aria-hidden="true" data-id="element-163" data-mp="3l0hy3z1x4hrw">
      <div className="absolute -left-4 top-6 flex flex-col gap-10 font-kanji text-[5rem] leading-none text-brand-goldDark/[0.07] md:text-[8rem]" data-id="element-164" data-mp="3q04ay7du3w06">
        {glyphs.slice(0, 3).map((glyph, index) => <span key={`${glyph}-${index}`} data-id="element-165" data-mp="3dh8yuyn4lzgk" data-mpi={index}>{glyph}</span>)}
      </div>
      <div className="absolute -right-4 bottom-6 flex flex-col gap-10 font-kanji text-[5rem] leading-none text-brand-goldDark/[0.07] md:text-[8rem]" data-id="element-166" data-mp="3dj3afmcicf7z">
        {glyphs.slice(3).map((glyph, index) => <span key={`${glyph}-${index}`} data-id="element-167" data-mp="3migkoh8gh7tr" data-mpi={index}>{glyph}</span>)}
      </div>
    </div>;
}

/** Thin fretwork divider with an optional centered character. */
export function FretDivider({
  character = '氣',
  className = ''
}: {
  character?: string;
  className?: string;
}) {
  return <div className={`flex items-center justify-center gap-4 ${className}`} aria-hidden="true" data-id="element-168" data-mp="38ixommsx5mxt">
      <span className="fret-rule w-20 opacity-70 sm:w-32" data-id="element-169" data-mp="33q4lu4h0good" />
      <span className="font-kanji text-lg text-brand-goldDark/70" data-id="element-170" data-mp="2g1ldxq1vidwt">
        {character}
      </span>
      <span className="fret-rule w-20 opacity-70 sm:w-32" data-id="element-171" data-mp="2b2i7q2a5q1n9" />
    </div>;
}